// Trait du temps, entre le scoreboard et le labyrinthe : plein au départ, il raccourcit par la gauche au fil des tics de
// l'adversaire et s'efface quand le temps est écoulé (core/scenarios/common.js#timeLeft). Entre deux tics, il glisse en ligne
// droite jusqu'à la nouvelle valeur, sur la durée d'un tic : il descend sans à-coups.
import { $ } from './dom.js';

export function createTimeBar() {
  const bar = $('timeBar');

  /**
   * @param {number} ratio part du temps qui reste, de 1 (plein) à 0 (effacé)
   * @param {number} [glideMs] durée de la glissade jusqu'à cette valeur ; 0 la pose d'un coup
   */
  function set(ratio, glideMs = 0) {
    bar.style.transition = glideMs > 0 ? `transform ${glideMs}ms linear` : 'none';
    bar.style.transform = `scaleX(${Math.max(0, Math.min(1, ratio))})`;
  }

  return { set };
}
